import React, { Component } from 'react'
import Collapsible from 'react-collapsible'
import FixedView from '../components/FixedView'
import ExistingForms from '../components/formBuilder/components/ExistingForms'
import { translate } from '../utils/useful'
import { formBuilderGroups, FormBuilderObjects } from '../variables/formBuilderData'
import PageBuilderHeader from './PageBuilderHeader'

export default class PageBuilderAddElements2 extends Component {
    state = {
        fixed: true,
        isExisting: true,
        formOptions: [
            { title: "Existing properties", className: "existing-forms" },
            { title: "Create new", className: "new-form" }
        ],
        activeTab: 0,
        closedGroups: {
            value: 'main'
        },

    }

    openFirstView = () => {
        let view = this.state.fixed
        this.setState({ fixed: !view }, () => {

            if (this.state.fixed == true) {
                this.firstView.hideView()
            } else {
                this.firstView.showView()

            }
        })
    }

    toggleOpen = (key) => {
        let closedGroups = this.state.closedGroups

        if (!closedGroups) {
            closedGroups = {}
        }
        closedGroups.value = key
        this.setState({ closedGroups }, () => {
            console.log(Object.values(this.state.closedGroups))
        })
    }

    onDragStart = (e, rowId, type) => {
        // e.preventDefault()
        let dataObject = { rowId, type, dropType: "NEW" };
        if (e.dataTransfer.setData) {
            e.dataTransfer.setData(
                "dragData",
                JSON.stringify(dataObject)
            );
        } else {
            e.dataTransfer.rowId = rowId;
            e.dataTransfer.type = type;
        }
        // this.props.showhandlers();
    };



    render() {
        const { formItems, hideHandlers } = this.props;
        return (
            <div className='w-100 h-100' ref={el => this.firstCurrentNode = el}>
                <div className='flexcb w-100'>
                    <div className='flexc'>
                        {Object.values(formBuilderGroups).map((group, index) => {
                            return (

                                <div className="px-2 py-2" key={group.key}>
                                    <button className={" flexc w-100 elements-hover2 p-2 br-5 " + (this.state.closedGroups.value == group.key ? "elements-select2" : "")} onClick={() => this.toggleOpen(group.key)}>
                                        <p className="">{group.title}</p>
                                        <img className='mld-3' width={20} src='/assets/icons/pagebuilder/all-filter.svg' />
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                    <div className='elemnts-search2 py-2 px-2 br-10 mrd-4'>
                        <div className='d-flex flexcb'>
                            <input className="w-100" onChange={e => this.changeValue(e)} value={this.state.search} type="text" placeholder="Search for an element" style={{ backgroundColor: 'transparent', }} />
                            <img style={{ width: '25px', height: '25px' }} src="/assets/icons/pagebuilder/search.svg" />
                        </div>
                    </div>
                </div>
                <Collapsible open={this.state.closedGroups ? true : false}>
                    <div style={{ backgroundColor: "#f6f6f6" }}>
                        {this.state.closedGroups.value && (
                            <div className='sc-3 flexc' style={{ overflowX: "scroll" }} >
                                {Object.values(FormBuilderObjects).map((formItem, index) => {
                                    if (formItem.parent == this.state.closedGroups.value)
                                        return (
                                            <div className="px-3 py-2 w-100" key={formItem.type}>
                                                <div key={index} className=" flexc w-100 text-smaller "
                                                    style={{ cursor: 'move' }}
                                                    onDragStart={(e) => this.onDragStart(e, index, formItem.type)}
                                                    onDragEnd={hideHandlers}
                                                    // onDragLeave={hideHandlers}
                                                    draggable={true}
                                                >
                                                    <img draggable={false} src={formItem.icon} height={22} />
                                                    <p draggable={false} className="mld-3">{formItem.label}</p>
                                                </div>
                                            </div>
                                        );
                                }
                                )}
                            </div>
                        )}
                    </div>
                </Collapsible>
            </div>
        )
    }
}
